<template>
  <material-view />
</template>

<script>
import { mapGetters } from 'vuex';
import MaterialView from '~/pages/articles/_id.vue';

export default {
  name: 'NewsPage',
  components: { MaterialView },
  layout: 'DefaultLayoutV2',
  computed: {
    ...mapGetters({
      categories: 'getMaterialCategories',
    }),
  },
  watch: {
    /**
     * Это динамическая страница.
     * По сути можно ввести любой адрес несуществующей страницы и попасть сюда
     * И если не соответствует эта страница существующей категории, переводим на 404
     */
    categories: {
      immediate: true,
      handler(categories) {
        if (categories.length) {
          const pageCategory = this.$route.params.material_category;
          const findCategory = this.categories.find(({ slug }) => pageCategory === slug);

          if (!findCategory) {
            this.$nuxt.error({ statusCode: 404 });
          }
        }
      },
    },
  },
};
</script>
